import {
  CHANGE_CURRENT_PAGE,
  CHANGE_SORT,
  CHANGE_SEARCH_STRING,
  CHANGE_ITEMS_PER_PAGE
} from "./types";
import Vue from "vue";

export const sortSearchPaginateMutations = {
  [CHANGE_CURRENT_PAGE](state, { payload }) {
    Vue.set(state, "currentPage", payload);
  },

  [CHANGE_SORT](state, { payload }) {
    Vue.set(state, "sorting", payload);
  },

  [CHANGE_SEARCH_STRING](state, { payload }) {
    Vue.set(state, "searchString", payload);
  },

  [CHANGE_ITEMS_PER_PAGE](state, { payload }) {
    Vue.set(state, "itemsPerPage", payload);
  }
};

export const sortSearchPaginateMutationsNewFormat = {
  [CHANGE_CURRENT_PAGE](state, { payload }) {
    Vue.set(state.pagination, "current_page", payload);
  },

  [CHANGE_SORT](state, { payload }) {
    Vue.set(state, "sort", payload);
  },

  [CHANGE_SEARCH_STRING](state, { payload }) {
    Vue.set(state.search, "value", payload);
  },

  [CHANGE_ITEMS_PER_PAGE](state, { payload }) {
    Vue.set(state.pagination, "page_size", payload);
  }
};
